import axios from "axios";

export const fetchGetCompaniesByParent = async (parentCompanyId?: string) => {
  const query = parentCompanyId ? `&parentCompanyId=${parentCompanyId}` : "";
  return await axios.get(`/api/company?pageSize=-1${query}`);
};
